module.exports = "img/icon_context_fave_on.dd832e0.svg";